// StatusBadge — icon + text status badge (never color alone, PSD §10.4/12). Presentation.

import type { ReactNode } from 'react';
import type { ValuationStatus } from '@backsolve/shared-types';
import { Award, Check, X, Circle, Loader, FileSearch } from 'lucide-react';

const LABELS: Record<ValuationStatus, string> = {
  draft: 'Draft',
  running: 'Running',
  converged: 'Converged',
  failed: 'Failed',
  inReview: 'In Review',
  finalized: 'Finalized',
};

const ICONS: Record<ValuationStatus, ReactNode> = {
  draft: <Circle aria-hidden="true" size={14} />,
  running: <Loader aria-hidden="true" size={14} />,
  converged: <Check aria-hidden="true" size={14} />,
  failed: <X aria-hidden="true" size={14} />,
  inReview: <FileSearch aria-hidden="true" size={14} />,
  finalized: <Award aria-hidden="true" size={14} />,
};

export function StatusBadge({ status }: { status: ValuationStatus }) {
  const cls = `badge badge-${status === 'inReview' ? 'review' : status}`;
  return (
    <span className={cls} aria-label={`Status: ${LABELS[status]}`}>
      <span aria-hidden="true">{ICONS[status]}</span>
      <span>{LABELS[status]}</span>
    </span>
  );
}
